// This is an auto generated file to import and export all available translations.
// Changes should not be checked into version control.
import TRANSLATE_AF from "./af/translations.json";
import TRANSLATE_AR from "./ar/translations.json";
import TRANSLATE_BG from "./bg/translations.json";
import TRANSLATE_CA from "./ca/translations.json";
import TRANSLATE_CS from "./cs/translations.json";
import TRANSLATE_DA from "./da/translations.json";
import TRANSLATE_DE from "./de/translations.json";
import TRANSLATE_DE_AT from "./de_AT/translations.json";
import TRANSLATE_DE_DE from "./de_DE/translations.json";
import TRANSLATE_EL from "./el/translations.json";
import TRANSLATE_EN from "./en/translations.json";
import TRANSLATE_EN_AT from "./en_AT/translations.json";
import TRANSLATE_EN_HU from "./en_HU/translations.json";
import TRANSLATE_ES from "./es/translations.json";
import TRANSLATE_ES_CU from "./es_CU/translations.json";
import TRANSLATE_ES_MX from "./es_MX/translations.json";
import TRANSLATE_ET from "./et/translations.json";
import TRANSLATE_ET_EE from "./et_EE/translations.json";
import TRANSLATE_FA from "./fa/translations.json";
import TRANSLATE_FA_IR from "./fa_IR/translations.json";
import TRANSLATE_FR from "./fr/translations.json";
import TRANSLATE_FR_CI from "./fr_CI/translations.json";
import TRANSLATE_GL from "./gl/translations.json";
import TRANSLATE_HI_IN from "./hi_IN/translations.json";
import TRANSLATE_HR from "./hr/translations.json";
import TRANSLATE_HU from "./hu/translations.json";
import TRANSLATE_HU_HU from "./hu_HU/translations.json";
import TRANSLATE_IT from "./it/translations.json";
import TRANSLATE_JA from "./ja/translations.json";
import TRANSLATE_KA from "./ka/translations.json";
import TRANSLATE_KO from "./ko/translations.json";
import TRANSLATE_LT from "./lt/translations.json";
import TRANSLATE_NE from "./ne/translations.json";
import TRANSLATE_NO from "./no/translations.json";
import TRANSLATE_PL from "./pl/translations.json";
import TRANSLATE_PT from "./pt/translations.json";
import TRANSLATE_RO from "./ro/translations.json";
import TRANSLATE_RU from "./ru/translations.json";
import TRANSLATE_RW from "./rw/translations.json";
import TRANSLATE_SK from "./sk/translations.json";
import TRANSLATE_SV from "./sv/translations.json";
import TRANSLATE_SV_SE from "./sv_SE/translations.json";
import TRANSLATE_TR from "./tr/translations.json";
import TRANSLATE_UK from "./uk/translations.json";
import TRANSLATE_UK_UA from "./uk_UA/translations.json";
import TRANSLATE_ZH_CN from "./zh_CN/translations.json";
import TRANSLATE_ZH_TW from "./zh_TW/translations.json";

export const translations = {
  af: { translation: TRANSLATE_AF },
  ar: { translation: TRANSLATE_AR },
  bg: { translation: TRANSLATE_BG },
  ca: { translation: TRANSLATE_CA },
  cs: { translation: TRANSLATE_CS },
  da: { translation: TRANSLATE_DA },
  de: { translation: TRANSLATE_DE },
  de_AT: { translation: TRANSLATE_DE_AT },
  de_DE: { translation: TRANSLATE_DE_DE },
  el: { translation: TRANSLATE_EL },
  en: { translation: TRANSLATE_EN },
  en_AT: { translation: TRANSLATE_EN_AT },
  en_HU: { translation: TRANSLATE_EN_HU },
  es: { translation: TRANSLATE_ES },
  es_CU: { translation: TRANSLATE_ES_CU },
  es_MX: { translation: TRANSLATE_ES_MX },
  et: { translation: TRANSLATE_ET },
  et_EE: { translation: TRANSLATE_ET_EE },
  fa: { translation: TRANSLATE_FA },
  fa_IR: { translation: TRANSLATE_FA_IR },
  fr: { translation: TRANSLATE_FR },
  fr_CI: { translation: TRANSLATE_FR_CI },
  gl: { translation: TRANSLATE_GL },
  hi_IN: { translation: TRANSLATE_HI_IN },
  hr: { translation: TRANSLATE_HR },
  hu: { translation: TRANSLATE_HU },
  hu_HU: { translation: TRANSLATE_HU_HU },
  it: { translation: TRANSLATE_IT },
  ja: { translation: TRANSLATE_JA },
  ka: { translation: TRANSLATE_KA },
  ko: { translation: TRANSLATE_KO },
  lt: { translation: TRANSLATE_LT },
  ne: { translation: TRANSLATE_NE },
  no: { translation: TRANSLATE_NO },
  pl: { translation: TRANSLATE_PL },
  pt: { translation: TRANSLATE_PT },
  ro: { translation: TRANSLATE_RO },
  ru: { translation: TRANSLATE_RU },
  rw: { translation: TRANSLATE_RW },
  sk: { translation: TRANSLATE_SK },
  sv: { translation: TRANSLATE_SV },
  sv_SE: { translation: TRANSLATE_SV_SE },
  tr: { translation: TRANSLATE_TR },
  uk: { translation: TRANSLATE_UK },
  uk_UA: { translation: TRANSLATE_UK_UA },
  zh_CN: { translation: TRANSLATE_ZH_CN },
  zh_TW: { translation: TRANSLATE_ZH_TW },
};
